var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.87,
    y: 7.83,
    width: 8.85,
    height: 3.66,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.87,
    y: 8.89,
    width: 2.3,
    height: 1.28,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7.91,
    width: 1.28,
    height: 0.71,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.81,
    y: 8.91,
    width: 0.91,
    height: 0.51,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.24,
    y: 9.11,
    width: 0.91,
    height: 0.51,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.09,
    y: 9.05,
    width: 2.17,
    height: 1.21,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.14,
    y: 10.35,
    width: 2.03,
    height: 1.13,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.79,
    y: 5.59,
    width: 14.44,
    height: 6.42,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2180",
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.49,
    y: 4.26,
    width: 19.18,
    height: 15.1,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.49,
    y: 4.26,
    width: 19.18,
    height: 15.1,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9141",
    d: "M19.27,9.95c0,.09,.07,.16,.16,.16h1.08v-.32h-1.08c-.09,0-.16,.07-.16,.16h0",
    style: {
      fill: "#493f42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9142",
    d: "M4.9,9.95c0,.09-.07,.16-.16,.16h-1.08v-.32h1.08c.09,0,.16,.07,.16,.16",
    style: {
      fill: "#493f42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9143",
    d: "M4.63,9.07v6.48h0c.01,.57,.23,1.11,.62,1.53,.46,.5,1.01,.91,1.62,1.2,.75,.36,1.54,.63,2.35,.79,1.89,.38,3.83,.38,5.71,0,.81-.16,1.61-.43,2.35-.79,.62-.29,1.17-.7,1.62-1.2,.38-.42,.6-.96,.62-1.53h0v-6.48H4.63Z",
    style: {
      fill: "#e02829"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9144",
    d: "M4.03,10.1c0-.42-.34-.77-.77-.77s-.77,.34-.77,.77v2.3h1.53v-2.3Z",
    style: {
      fill: "#493f42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9145",
    d: "M2.49,12.4c0,.42,.34,.77,.77,.77s.77-.34,.77-.77-.34-.77-.77-.77h0c-.42,0-.77,.34-.77,.77",
    style: {
      fill: "#686163"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9146",
    d: "M5.16,12.4c0,.1-.08,.18-.18,.18h-1.19v-.36h1.19c.1,0,.18,.08,.18,.18h0",
    style: {
      fill: "#686163"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9147",
    d: "M20.14,10.1c0-.42,.34-.77,.77-.77,.42,0,.77,.34,.77,.77h0v2.3h-1.53v-2.3Z",
    style: {
      fill: "#493f42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9148",
    d: "M21.68,12.4c0,.42-.34,.77-.77,.77s-.77-.34-.77-.77c0-.42,.34-.77,.77-.77h0c.42,0,.77,.34,.77,.77",
    style: {
      fill: "#686163"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9149",
    d: "M19.01,12.4c0,.1,.08,.18,.18,.18h1.19v-.36h-1.19c-.1,0-.18,.08-.18,.18h0",
    style: {
      fill: "#686163"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9150",
    d: "M18.92,16.32c-.46,.48-1.01,.87-1.62,1.14-.75,.34-1.54,.6-2.35,.75-1.89,.36-3.83,.36-5.71,0-.81-.15-1.6-.41-2.35-.75-.61-.27-1.16-.66-1.62-1.14-.29-.31-.5-.7-.59-1.11-.02,.12-.03,.23-.03,.35,.01,.57,.23,1.11,.62,1.53,.46,.5,1.01,.91,1.62,1.2,.75,.36,1.54,.63,2.35,.79,1.89,.38,3.83,.38,5.71,0,.81-.16,1.61-.43,2.35-.79,.62-.29,1.17-.7,1.62-1.2,.38-.42,.6-.96,.62-1.53,0-.12-.01-.24-.03-.35-.09,.42-.29,.8-.59,1.11",
    style: {
      fill: "#615358"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9151",
    d: "M5.25,16.32c.46,.48,1.01,.87,1.62,1.14,.71,.32,1.45,.57,2.21,.72-.95-.71-1.53-1.81-1.57-2.99v-6.11h-2.88v6.48c0-.12,.01-.24,.03-.35,.09,.42,.29,.8,.59,1.11",
    style: {
      fill: "#d30918"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9152",
    d: "M9.08,18.17c-.76-.15-1.5-.4-2.21-.72-.61-.27-1.16-.66-1.62-1.14-.29-.31-.5-.7-.59-1.11-.02,.12-.03,.23-.03,.35,.01,.57,.23,1.11,.62,1.53,.46,.5,1.01,.91,1.62,1.2,.75,.36,1.54,.63,2.35,.79,.94,.19,1.9,.29,2.86,.29h.19c-1.15-.1-2.26-.51-3.2-1.18",
    style: {
      fill: "#493f42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9153",
    d: "M18.92,7.78c-.47-.44-1.02-.78-1.62-1.01-.76-.31-1.55-.53-2.35-.67-1.89-.32-3.82-.32-5.71,0-.81,.14-1.6,.36-2.35,.67-.6,.23-1.15,.58-1.62,1.01-.37,.33-.6,.79-.62,1.29,.02,.5,.24,.96,.62,1.29,.47,.44,1.02,.78,1.62,1.01,.76,.31,1.55,.53,2.35,.67,.94,.16,1.9,.24,2.86,.24,.96,0,1.91-.08,2.86-.24,.81-.14,1.6-.36,2.35-.67,.6-.23,1.15-.58,1.62-1.02,.37-.33,.59-.79,.62-1.29-.02-.5-.24-.96-.62-1.29",
    style: {
      fill: "#ecefe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9154",
    d: "M19.07,9.07c0,1.62-3.12,2.93-6.98,2.93s-6.98-1.31-6.98-2.93,3.12-2.93,6.98-2.93,6.98,1.31,6.98,2.93",
    style: {
      fill: "#5a1c21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9155",
    d: "M12.08,6.14c-2.92,0-5.42,.75-6.46,1.82,1.63-.66,3.37-.98,5.13-.94,3.85,0,6.98,1.31,6.98,2.93-.02,.42-.2,.82-.52,1.11,1.15-.52,1.85-1.22,1.85-1.99,0-1.62-3.12-2.93-6.98-2.93",
    style: {
      fill: "#4f0f15"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9156",
    d: "M12.09,11.98c-1.36,.01-2.71-.17-4.02-.54-.94-.22-1.8-.69-2.5-1.36,.7-.67,1.56-1.13,2.5-1.36,1.31-.37,2.66-.55,4.02-.54,1.36-.01,2.72,.17,4.02,.54,.94,.22,1.8,.69,2.5,1.36-.7,.67-1.56,1.13-2.5,1.36-1.31,.37-2.66,.55-4.02,.54",
    style: {
      fill: "#a5d7f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9157",
    d: "M12.09,8.21c1.36-.01,2.71,.17,4.02,.54,.52,.15,1.02,.35,1.49,.6,.37,.19,.7,.44,.99,.74-.29,.3-.62,.55-.99,.74-.48,.25-.98,.45-1.49,.6-1.31,.37-2.66,.55-4.02,.54-1.36,.01-2.71-.17-4.02-.54-.52-.15-1.02-.35-1.49-.6-.37-.19-.7-.44-.99-.74,.29-.3,.62-.55,.99-.74,.48-.25,.98-.45,1.49-.6,1.31-.37,2.66-.55,4.02-.54m0-.03c-3,0-5.56,.8-6.55,1.91,.99,1.12,3.55,1.91,6.55,1.91s5.56-.8,6.55-1.91c-.99-1.12-3.54-1.91-6.55-1.91",
    style: {
      fill: "#c2e4f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4899",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4898"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4881",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4880"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9158",
    d: "M10.18,9.7c0,.39-.51,.48-1.15,.48s-1.15-.09-1.15-.48,.52-.81,1.15-.81,1.15,.42,1.15,.81",
    style: {
      fill: "#55b5c3"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9159",
    d: "M9.96,9.48c0,.35-.42,.44-.94,.44s-.94-.08-.94-.44c.13-.52,.65-.83,1.17-.71,.35,.09,.62,.36,.71,.71",
    style: {
      fill: "#c2e4f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4884",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4883"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9160",
    d: "M13.28,8.36c0,.22-.29,.27-.64,.27s-.64-.05-.64-.27,.29-.45,.64-.45,.64,.23,.64,.45",
    style: {
      fill: "#55b5c3"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9161",
    d: "M13.16,8.24c0,.2-.23,.24-.52,.24s-.52-.05-.52-.24c.07-.29,.36-.46,.65-.39,.19,.05,.35,.2,.39,.39",
    style: {
      fill: "#c2e4f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4887",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4886"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9162",
    d: "M16.72,9.23c0,.15-.2,.19-.46,.19s-.46-.04-.46-.19,.2-.32,.46-.32,.46,.17,.46,.32",
    style: {
      fill: "#55b5c3"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9163",
    d: "M16.64,9.14c0,.14-.17,.17-.37,.17s-.37-.03-.37-.17c.05-.2,.26-.33,.46-.28,.14,.03,.25,.14,.28,.28",
    style: {
      fill: "#c2e4f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4890",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4889"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9164",
    d: "M12.16,9.42c0,.15-.2,.19-.46,.19s-.46-.04-.46-.19,.2-.32,.46-.32,.46,.17,.46,.32",
    style: {
      fill: "#55b5c3"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9165",
    d: "M12.07,9.34c0,.14-.17,.17-.37,.17s-.37-.03-.37-.17c.05-.2,.26-.33,.46-.28,.14,.03,.25,.14,.28,.28",
    style: {
      fill: "#c2e4f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4893",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4892"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9166",
    d: "M16.27,9.81c0,.37-.49,.45-1.09,.45s-1.09-.09-1.09-.45,.49-.76,1.09-.76,1.09,.39,1.09,.76",
    style: {
      fill: "#55b5c3"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9167",
    d: "M16.06,9.6c0,.33-.4,.41-.88,.41s-.88-.08-.88-.41c.12-.49,.61-.79,1.1-.67,.33,.08,.58,.34,.67,.67",
    style: {
      fill: "#c2e4f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4896",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4895"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-6)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9168",
    d: "M13.17,11.06c0,.34-.46,.42-1.01,.42s-1.01-.08-1.01-.42,.46-.71,1.01-.71,1.01,.37,1.01,.71",
    style: {
      fill: "#55b5c3"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9169",
    d: "M12.98,10.87c0,.31-.37,.39-.83,.39s-.83-.07-.83-.39c.11-.46,.57-.74,1.03-.63,.31,.08,.55,.32,.63,.63",
    style: {
      fill: "#c2e4f1"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9170",
    d: "M15.23,6.68c.63,.13,1.24,.32,1.84,.56,.55,.21,1.06,.53,1.49,.93,.29,.25,.47,.61,.5,1-.02,.39-.2,.75-.5,1-.44,.4-.95,.71-1.5,.92-.73,.3-1.49,.51-2.27,.64-.92,.16-1.85,.24-2.79,.23-.93,0-1.87-.08-2.79-.24-.15-.03-.29-.05-.43-.08-.63-.13-1.24-.32-1.84-.56-.55-.21-1.06-.53-1.49-.93-.29-.25-.47-.61-.49-1,.02-.39,.2-.75,.5-1,.44-.4,.95-.71,1.5-.93,.73-.3,1.49-.51,2.27-.64,1.84-.31,3.73-.31,5.57,0,.15,.03,.29,.05,.43,.08m.08-.4c-.14-.03-.29-.06-.44-.09-1.89-.32-3.82-.33-5.71,0-.81,.13-1.6,.36-2.35,.66-.6,.23-1.15,.57-1.62,1.01-.37,.33-.6,.79-.62,1.29,.02,.5,.24,.96,.61,1.29,.47,.44,1.02,.78,1.62,1.01,.62,.25,1.26,.45,1.91,.58,.14,.03,.29,.06,.44,.09,.94,.16,1.9,.25,2.86,.25,.96,0,1.91-.08,2.86-.24,.81-.13,1.6-.36,2.35-.66,.6-.23,1.15-.58,1.62-1.01,.37-.33,.6-.79,.62-1.29-.02-.49-.24-.96-.61-1.29-.47-.44-1.02-.78-1.62-1.02-.62-.25-1.26-.45-1.91-.58",
    style: {
      fill: "#686163"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4901"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-7)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9171",
    d: "M18.64,7.52c-.45-.44-.99-.78-1.57-1.02-.73-.31-1.5-.53-2.28-.67-1.83-.32-3.71-.33-5.54,0-.78,.13-1.55,.36-2.28,.66-.58,.23-1.12,.58-1.57,1.01-.36,.33-.58,.8-.6,1.29,.02,.49,.24,.96,.6,1.29,.45,.43,.99,.78,1.57,1.01,.73,.31,1.5,.53,2.28,.67,.91,.16,1.84,.25,2.77,.24,.93,0,1.86-.08,2.77-.24,.78-.14,1.55-.36,2.28-.66,.58-.23,1.12-.58,1.58-1.01,.36-.33,.58-.8,.6-1.29-.02-.49-.24-.96-.6-1.29",
    style: {
      fill: "#ecefe0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4900-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9171-2",
    d: "M18.64,7.52c-.45-.44-.99-.78-1.57-1.02-.73-.31-1.5-.53-2.28-.67-1.83-.32-3.71-.33-5.54,0-.78,.13-1.55,.36-2.28,.66-.58,.23-1.12,.58-1.57,1.01-.36,.33-.58,.8-.6,1.29,.02,.49,.24,.96,.6,1.29,.45,.43,.99,.78,1.57,1.01,.73,.31,1.5,.53,2.28,.67,.91,.16,1.84,.25,2.77,.24,.93,0,1.86-.08,2.77-.24,.78-.14,1.55-.36,2.28-.66,.58-.23,1.12-.58,1.58-1.01,.36-.33,.58-.8,.6-1.29-.02-.49-.24-.96-.6-1.29",
    style: {
      fill: "#ecefe0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9172",
    d: "M18.64,7.52c-.45-.44-.99-.78-1.57-1.02-.73-.31-1.5-.53-2.28-.67-.91-.16-1.84-.25-2.77-.24h-.35c.24,.1,0,.51,.23,.6,3.16,1.3,4.58,4.84-2.31,5.63,.8,.12,1.61,.19,2.42,.19,.93,0,1.86-.08,2.77-.24,.78-.14,1.55-.36,2.28-.66,.58-.23,1.12-.57,1.57-1,.36-.33,.58-.8,.6-1.29-.02-.49-.24-.96-.6-1.29",
    style: {
      fill: "#d9dbce"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9173",
    d: "M13.27,5.96c-.09-.08-.19-.15-.3-.19-.14-.06-.28-.1-.43-.13-.35-.06-.7-.06-1.05,0-.15,.03-.29,.07-.43,.13-.11,.04-.21,.11-.3,.19-.13,.11-.15,.31-.04,.45,.01,.01,.02,.03,.04,.04,.09,.08,.19,.15,.3,.19,.14,.06,.28,.1,.43,.13,.35,.06,.7,.06,1.05,0,.15-.03,.29-.07,.43-.13,.11-.04,.21-.11,.3-.19,.13-.11,.15-.32,.04-.45-.01-.01-.02-.03-.04-.04",
    style: {
      fill: "#e02829"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9174",
    d: "M13.05,5.29c0,.57-.46,1.03-1.03,1.03-.57,0-1.03-.46-1.03-1.03,0-.57,.46-1.03,1.03-1.03,.57,0,1.03,.46,1.03,1.03h0",
    style: {
      fill: "#e02829"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9175",
    d: "M13.27,5.96c-.09-.08-.19-.15-.3-.19h-.03c.25-.52,.05-1.14-.46-1.4-.09-.05-.19-.08-.29-.09,.34,.37,.5,.88,.44,1.38-.02,.1-.05,.2-.09,.3-.05,.13-.13,.24-.24,.33-.47,.27-1.04,.33-1.55,.14h0c.09,.09,.19,.16,.3,.2,.14,.06,.28,.1,.43,.13,.17,.03,.35,.05,.52,.05,.18,0,.35-.01,.53-.05,.15-.03,.29-.07,.43-.13,.11-.04,.21-.11,.3-.19,.07-.06,.11-.15,.11-.24,0-.09-.04-.18-.11-.24",
    style: {
      fill: "#d30918"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPot);
export default __webpack_public_path__ + "static/media/pot.30879f9632e36d1cc79a23cc7ab9c316.svg";
export { ForwardRef as ReactComponent };